export const copyToClipboard = async (content: string): Promise<void> => {
  await navigator.clipboard.writeText(content);
};
